import { useCapabilitiesContext } from "../shared/context";

export const useCapabilities = (): any => {

    const { can, canRoute, getFirstAccessibleRoute } = useCapabilitiesContext();

    return {
        can,
        canRoute,
        getFirstAccessibleRoute,
    };

};